// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2HQBX","text":"SelectPayment_text__2Sry6","title":"SelectPayment_title__3xrLD","btn":"SelectPayment_btn__1Tmju"};